import apiAgent from "../api/apiAgent";

/**
 * Setup the schemas and default values for single items.
 *
 * The object name MUST match that in the config.json or
 * config-dev.json single item names in the Go backend.
 *
 * publishing single items do not need to be put here.
 *
 * Example:
 *
 * single_item_name_as_in_config: {
 *   schema: {
 *     name_of_field: "string",
 *     number_field: "number",
 *   },
 *   defaultValue: {
 *     number_field: 3,
 *   },
 * },
 */

export const singleItemsConfig = {
  example: {
    schema: {
      example_field: "string",
    },
    defaultValue: {
      example_field: "hello world",
      attract_subtitle: null,
    },
  },
};

const checkSingleItem = async (item: keyof typeof singleItemsConfig) => {
  const config = singleItemsConfig[item];
  try {
    const response = await apiAgent.SingleItem.get(item);
    const schema = response?.data?.schema;
    if (!schema)
      throw `Error retrieving schema of ${item} or item is not in config file`;

    const strigifiedConfigSchema = JSON.stringify(config.schema);
    if (schema !== strigifiedConfigSchema) {
      await apiAgent.SingleItem.update(
        item,
        config.defaultValue,
        strigifiedConfigSchema
      );
    }
  } catch (err) {
    console.log(err);
  }
};

/**
 * ASync function to update all single item schemas based on "singleItemsConfig"
 * To setup the schemas for single items, go to src/utils/singleItemsConfig.tsx
 */
export const checkSingleItemSchemas = async () => {
  try {
    const singleItems = Object.keys(singleItemsConfig).filter(
      (key) => key !== "example"
    );
    await Promise.all(
      singleItems.map((item) =>
        checkSingleItem(item as keyof typeof singleItemsConfig)
      )
    );
  } catch (err) {}
};
